import EqualHeights from "@solundo/webshop/js/EqualHeights/EqualHeights";
new EqualHeights();